import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'xero/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('xero/', '')
      .toLowerCase();
  }
}
